import { Component, ElementRef, ViewChild } from '@angular/core';

import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditor, ICellEditorParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'agCombo',
  templateUrl: './agCombo.component.html',
  styles: ['select{border:none;background:none;outline: none;}'],
})
export class ComboEditor implements ICellEditorAngularComp {
  @ViewChild('input') public input: ElementRef;
  public params: ICellEditorParams|any;
  public unlinkValue: boolean = false;

  agInit(params: any): void {
    this.params = params;   
    //params.param existe pas si on passe param en ICellEditorParams
    this.unlinkValue = !(this.params.param as Array<{ id: string, value: string }>).some(x => x.id == this.params.value);
  }

  getValue(): string {
    return this.params.value;
  }


  changeValue(param: any): void {
    this.params.value = param;
    this.params.api?.stopEditing();
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }


  afterGuiAttached() {
    //TODO ouverture de la select 
  }
}
